import { ContextualHomeHero } from '@/features/home/ContextualHomeHero'

export function HomePage() {
  return (
    <main className="flex flex-col h-full">
      <ContextualHomeHero />
    </main>
  )
}
